<template>
  <div>
    <div class="sidebar-container">
      <div class="sidebar-logo text-center">Kabbik Admin</div>
      <nav class="sidebar py-2 mb-4">
        <ul class="nav flex-column" id="nav_accordion">
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/home">
              <i class="fas fa-volume-up me-2"></i>Dashboard
            </router-link>
          </li>
          <li class="nav-items" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/play-count-master"><i class="fas fa-play me-2"></i> Play Counts
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/master-top-user"><i class="fas fa-user me-2"></i> Top User
            </router-link>
          </li>

          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/audiobookAnalytics"><i class="fas fa-chart-line me-2"></i> AudioBook Analytics
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/channels">
              <i class="fas fa-desktop me-2"></i>Channels
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/audiobooklist">
              <i class="fas fa-music me-2"></i>Audio Book List
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/recording">
              <i class="fas fa-microphone-alt me-2"></i>Book Recording Management
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/book-request-list">
              <i class="fas fa-music me-2"></i>Book Request List
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/upcoming-book-list">
              <i class="fas fa-music me-2"></i>Upcoming Book List
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/daily-audiobook-playlist">
              <i class="fas fa-music me-2"></i>Daily AudioBook Playlist
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/approval">
              <i class="fas fa-check-circle me-2"></i>Approval
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/creators">
              <i class="fa fa-user me-2"></i>Creators
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/publisher-management">
              <i class="fa fa-user me-2"></i>Publisher Management
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/payment">
              <i class="fas fa-money-check-alt me-2"></i>Payment
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/category">
              <i class="fas fa-th me-2"></i>Category
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/blog-list">
              <i class="fas fa-blog me-2"></i>Blog List
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/refund">
              <i class="fas fa-reply-all me-2"></i>Refund
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/review-list">
              <i class="fas fa-comments me-2"></i>Review List
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/subscribe-user-list">
              <i class="fas fa-reply-all me-2"></i>Subscribe user list
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/promo">
              <i class="fas fa-reply-all me-2"></i>Promo Code
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/first-subscribed-try-then-failed">
              <i class="fas fa-reply-all me-2"></i>First subscribed failed
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/was-subscribed-then-canceled">
              <i class="fas fa-reply-all me-2"></i>Was
              subscribed-then-canceled
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/latest-transactions-list">
              <i class="fas fa-reply-all me-2"></i>Latest Transactions list
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/author-list">
              <i class="fas fa-pen-nib me-2"></i>Author
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/cast-crew-list">
              <i class="fas fa-user-injured me-2"></i>Cast & Crew
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/quiz-participants-list">
              <i class="fas fa-reply-all me-2"></i>Quiz participants list
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/quiz-question">
              <i class="fas fa-question-circle me-2"></i>Quiz Questions
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/quiz-winner-list">
              <i class="fas fa-trophy me-2"></i>Quiz Winner list
            </router-link>
          </li>
          <li class="nav-item" v-on:click="closeSideDrawer">
            <router-link class="nav-link sidebar_link" to="/notification">
              <i class="fas fa-bell me-2"></i>Notification push
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div id="mobile_sidebar">
      <div class="sidebar-logo text-center position-relative">
        Kabbik
        <span class="close_btn" v-on:click="closeSideDrawer">
          <i class="fas fa-times-circle"></i>
        </span>
      </div>
      <nav class="sidebar py-2 mb-4">
        <ul class="nav flex-column" id>
          <ul class="nav flex-column" id="nav_accordion">
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/home">
                <i class="fas fa-volume-up me-2"></i>Dashboard
              </router-link>
            </li>

            <li class="nav-items" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/play-count-master"><i class="fas fa-play me-2"></i> Play Counts
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/master-top-user"><i class="fas fa-user me-2"></i> Top User
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/audiobookAnalytics"><i class="fas fa-chart-line me-2"></i> AudioBook Analytics
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/channels">
                <i class="fas fa-desktop me-2"></i>Channels
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/audiobooklist">
                <i class="fas fa-music me-2"></i>Audio Book List
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/recording">
                <i class="fas fa-microphone-alt me-2"></i>Book Recording Management
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/book-request-list">
                <i class="fas fa-music me-2"></i>Book Request List
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/upcoming-book-list">
                <i class="fas fa-music me-2"></i>Upcoming Book List
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/daily-audiobook-playlist">
                <i class="fas fa-music me-2"></i>Daily AudioBook Playlist
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/approval">
                <i class="fas fa-check-circle me-2"></i>Approval
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/creators">
                <i class="fa fa-user me-2"></i>Creators
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/publisher-management">
                <i class="fa fa-user me-2"></i>Publisher Management
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/payment">
                <i class="fas fa-money-check-alt me-2"></i>Payment
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/category">
                <i class="fas fa-th me-2"></i>Category
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/blog-list">
                <i class="fas fa-blog me-2"></i>Blog List
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/refund">
                <i class="fas fa-reply-all me-2"></i>Refund
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/review-list">
                <i class="fas fa-comments me-2"></i>Review List
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/subscribe-user-list">
                <i class="fas fa-reply-all me-2"></i>Subscribe user list
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/promo">
                <i class="fas fa-reply-all me-2"></i> Promo Code
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/first-subscribed-try-then-failed">
                <i class="fas fa-reply-all me-2"></i>First subscribed failed
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/was-subscribed-then-canceled">
                <i class="fas fa-reply-all me-2"></i>Was
                subscribed-then-canceled
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/latest-transactions-list">
                <i class="fas fa-reply-all me-2"></i>Latest Transactions list
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/author-list">
                <i class="fas fa-pen-nib me-2"></i>Author
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/cast-crew-list">
                <i class="fas fa-user-injured me-2"></i>Cast & Crew
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/quiz-participants-list">
                <i class="fas fa-trophy me-2"></i>Quiz participants list
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/quiz-question">
                <i class="fas fa-question-circle me-2"></i>Quiz Questions
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/quiz-winner-list">
                <i class="fal fa-trophy me-2"></i>Quiz Winner list
              </router-link>
            </li>
            <li class="nav-item" v-on:click="closeSideDrawer">
              <router-link class="nav-link sidebar_link" to="/notification">
                <i class="fas fa-bell me-2"></i>Notification push
              </router-link>
            </li>

          </ul>
        </ul>
      </nav>
    </div>
    <div id="side-drawer-void" class="position-fixed d-none" v-on:click="closeSideDrawer"></div>
  </div>
</template>

<script>
// import("../../assets/js/bootstrap.bundle.min.js");
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sidebar .nav-link").forEach(function (element) {
    element.addEventListener("click", function (e) {
      let nextEl = element.nextElementSibling;
      let parentEl = element.parentElement;

      if (nextEl) {
        e.preventDefault();
        let mycollapse = new bootstrap.Collapse(nextEl);

        if (nextEl.classList.contains("show")) {
          mycollapse.hide();
        } else {
          mycollapse.show();
          // find other submenus with class=show
          var opened_submenu = parentEl.parentElement.querySelector(
            ".submenu.show"
          );
          // if it exists, then close all of them
          if (opened_submenu) {
            new bootstrap.Collapse(opened_submenu);
          }
        }
      }
    }); // addEventListener
  }); // forEach
});
export default {
  methods: {
    closeSideDrawer: function () {
      document.getElementById("mobile_sidebar").style.left = "-100%";
      document.getElementById("mobile_sidebar").style.transition = "2s";
      document.getElementById("side-drawer-void").classList.add("d-none");
      document.getElementById("side-drawer-void").classList.remove("d-block");
    },


  }
};
</script>

<style scoped>
a.active {
  background: #8d8bff;
  border-radius: 3px;
}

.collapse {
  background: black;
  color: white
}

a {
  color: white
}

a:hover {
  color: white;
  background: #8d8bff;
}

/* ul .nav-link[data-toggle].collapsed:after {
    content: " ▾";
}
ul .nav-link[data-toggle]:not(.collapsed):after {
    content: " ▴";
} */
</style>
